(function (win, doc) {
  'use strict';

  function initCarousel(root) {
    var viewport = root.querySelector('[data-bs-grid-viewport]');
    var thumb = root.querySelector('[data-bs-grid-thumb]');
    var track = root.querySelector('[data-bs-grid-track]');
    var prev = root.querySelector('[data-bs-grid-prev]');
    var next = root.querySelector('[data-bs-grid-next]');
    var slides = root.querySelectorAll('.homepage-bestsellers-grid__carousel-slide');

    if (!viewport || !thumb) return;
    if (!track) track = thumb.parentElement;

    function updateThumb() {
      var trackWidth = track.clientWidth;
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;

      if (maxScroll <= 0 || trackWidth <= 0) {
        thumb.style.width = trackWidth > 0 ? trackWidth + 'px' : '100%';
        thumb.style.transform = 'translateX(0px)';
        if (prev) prev.disabled = true;
        if (next) next.disabled = true;
        return;
      }

      if (prev) prev.disabled = viewport.scrollLeft <= 2;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll - 2;

      var thumbWidthPx = (viewport.clientWidth / viewport.scrollWidth) * trackWidth;
      if (thumbWidthPx < 24) thumbWidthPx = 24;
      if (thumbWidthPx > trackWidth) thumbWidthPx = trackWidth;

      var maxTravel = trackWidth - thumbWidthPx;
      var scrollRatio = viewport.scrollLeft / maxScroll;
      if (scrollRatio < 0) scrollRatio = 0;
      if (scrollRatio > 1) scrollRatio = 1;

      thumb.style.width = thumbWidthPx + 'px';
      thumb.style.transform = 'translateX(' + (scrollRatio * maxTravel) + 'px)';
    }

    function scrollToSlide(direction) {
      if (!slides.length) {
        viewport.scrollBy({ left: viewport.clientWidth * 0.82 * direction, behavior: 'smooth' });
        return;
      }

      var current = viewport.scrollLeft;
      var target = null;
      var i;
      var slide;
      var slideLeft;

      if (direction > 0) {
        for (i = 0; i < slides.length; i++) {
          slide = slides[i];
          slideLeft = slide.offsetLeft;
          if (slideLeft > current + 4) {
            target = slideLeft;
            break;
          }
        }
        if (target === null) {
          target = viewport.scrollWidth - viewport.clientWidth;
        }
      } else {
        for (i = slides.length - 1; i >= 0; i--) {
          slide = slides[i];
          slideLeft = slide.offsetLeft;
          if (slideLeft < current - 4) {
            target = slideLeft;
            break;
          }
        }
        if (target === null) {
          target = 0;
        }
      }

      viewport.scrollTo({ left: target, behavior: 'smooth' });
    }

    viewport.addEventListener('scroll', updateThumb, { passive: true });
    win.addEventListener('resize', updateThumb);
    viewport.addEventListener('load', updateThumb, true);

    if ('onscrollend' in viewport) {
      viewport.addEventListener('scrollend', updateThumb, { passive: true });
    }

    if (win.ResizeObserver) {
      var observer = new win.ResizeObserver(updateThumb);
      observer.observe(viewport);
      observer.observe(track);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollToSlide(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        scrollToSlide(1);
      });
    }

    updateThumb();
    win.setTimeout(updateThumb, 100);
    win.setTimeout(updateThumb, 500);
  }

  function initAll() {
    var carousels = doc.querySelectorAll('[data-bs-grid-carousel]');
    for (var i = 0; i < carousels.length; i++) {
      initCarousel(carousels[i]);
    }
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})(window, document);
